import { DAPI_HOST } from '../../config/index';

const getLeadsUrl = () => `${DAPI_HOST}/v1/leads`;

export { getLeadsUrl };
